import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { closeInspectApplicationModal, selectCurrentApplication, selectInspectJobApplicationModalOpen } from "../../model"
import { Modal } from "@/shared/ui/modal"
import { monthsGenitive } from "@/shared/consts/month-names"
import { IProfileField } from "@/shared/api/profilebuilder"
import PaperclipSvg from '@/shared/assets/images/Paperclip.svg'
import { toLocaleDateString } from "@/shared/lib/date-formatters"

export const InspectJobApplicationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectInspectJobApplicationModalOpen)
    const application = useAppSelector(selectCurrentApplication)

    const handleClose = () => {
        dispatch(closeInspectApplicationModal())
    }

    const renderTemplateField = (field: IProfileField) => {
        let value = application.values[field.id]
        let valueComponent: React.ReactNode = value

        if (field.type === 'photo') {
            valueComponent = value ? <img src={value} className='object-cover w-[100px] h-[100px]' alt="" /> : "—"
        } else if (field.type === 'file') {
            valueComponent = value ? <a href={value} className='text-color-primary inline-flex items-center hover:cursor-pointer hover:underline'><PaperclipSvg width={16} height={16} className="me-1" /> Приложение</a> : "—"
        } else if (field.type === 'date') {
            const date = value ? new Date(value) : new Date()
            valueComponent = value ? `${date.getDate()} ${monthsGenitive[date.getMonth()]} ${date.getFullYear()}` : "—"
        }

        return (
            <div className="col-span-6 w-full flex flex-col pb-2 border-b border-[#B9C9C6] mb-3">
                <div className="text-[#828282] uppercase font-semibold text-[12px] mb-2">
                    {field.title}
                </div>
                <div className="text-[13px] font-semibold">
                    {valueComponent ?? "—"}
                </div>
            </div>
        )
    }


    return (
        <Modal
            isOpen={isOpen}
            title={(
                <div>
                    ПРОСМОТР ЗАЯВКИ <br />
                    {Boolean(application.created_at) &&
                        toLocaleDateString(application.created_at)
                    }
                </div>
            )}
            onRequestClose={handleClose}       
        >
            <div className="text-color-primary font-mediumttf mb-3">
                АНКЕТА
            </div>
            {!application.job_opening.template.length &&         
                <div className="mb-3">Пустая анкета</div>
            }
            {!!application.job_opening.template.length &&                                
                <div className="grid grid-cols-12 gap-x-3">
                    {application.job_opening.template.map(field => renderTemplateField(field))}
                </div>
            }
            <div className="w-full flex">
                <button onClick={handleClose} className="form_cancel_button">
                    Закрыть
                </button>
            </div>
        </Modal>
    )
}